export const EMPTY_STRING: string = '';